import {prepareDeleteDialog} from './dialog_helper.js';

$(document).ready(() => $('.soft-delete-DeviceType').click(function(e) {
    e.preventDefault();
    const url = $(this).data('data-source');
    const hardDelete = $(this).data('hard-delete');
    const title = $(this).data('title');
    const inactive = "hide";
    return $.ajax({
        url,
        type: 'GET',
        dataType: 'json',
        success(returnedData) { 
            return prepareDeleteDialog('device-type', url, returnedData, hardDelete, title, inactive);
        }
    });
}));       
